<template>
  <div>
    <v-progress-linear
      v-if="!getCertificates"
      indeterminate
      color="#006CA1"
      class="mt-3"
      style="top: -20px"
    ></v-progress-linear>
    <div class="certificates-wrapper">
      <certificates-new-filters-index
        type="certificates"
        :filters="filters"
        @resetAllDateModals="resetAllDateModals"
      />
      <certificates-table-index />
    </div>
    <v-tooltip top v-if="hasRoles(constants.CREATE_CERTIFICATE_ROLES)">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="#487A7B"
          @click="$router.push({ name: 'Submit certificate request' })"
          dark
          fab
          bottom
          fixed
          right
          depressed
          v-bind="attrs"
          v-on="on"
        >
          <v-icon large class="csr-button">fa-thin fa-plus</v-icon>
        </v-btn>
      </template>
      <span>Submit certificate request</span>
    </v-tooltip>
  </div>
</template>

<script>
import CertificatesToolBar from "@/components/certificates/certificates-table/certificates-table-tool-bar.vue";
import CertificateFiltersIndex from "@/components/certificates/certificates-filters/certificates-filters-index.vue";
import CertificatesTableIndex from "@/components/certificates/certificates-table/certificates-table-index.vue";
import CertificatesNewFiltersIndex from "@/components/certificates/certificates-filters/certificates-filters-index.vue";
import { mapGetters } from "vuex";
import { certFilters } from "@/plugins/mockups";
import * as constants from "@/config/constants";
export default {
  components: {
    CertificatesNewFiltersIndex,
    CertificatesTableIndex,
    CertificateFiltersIndex,
    CertificatesToolBar,
  },
  computed: {
    constants() {
      return constants;
    },
    ...mapGetters(["getCertificates", "getRoles"]),
  },
  data() {
    return {
      filters: certFilters,
    };
  },
  methods: {
    hasRoles(roles) {
      return roles.every((role) => this.getRoles.includes(role));
    },
    resetAllDateModals() {
      // For each change of variation  the models (current solution not working)
      this.filters.forEach((filter) => {
        if (filter.type === "date") {
          filter.models.isOn = "";
          filter.models.isBefore = "";
          filter.models.isAfter = "";
          filter.models.isInTheRange = "";
          filter.models.isWithin = "";
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/style/main.scss";
.certificates-wrapper {
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

@media (min-width: 768px) {
  .certificates-wrapper {
    padding-top: 0px;
  }
}

@media screen and (min-width: 0px) and (max-width: 960px) {
  /* Your styles for this range go here */
  ::v-deep .v-btn--fab.v-size--default {
    height: 40px;
    width: 40px;
  }

  .csr-button {
    font-size: 1.7rem !important;
  }
}
</style>
